import { accordionAndTextTemplate1Blueprint } from "@made-people/blueprint-accordion-and-text/blueprint";

accordionAndTextTemplate1Blueprint.override({
  slots: {
    wrapper:
      "flex flex-col w-full md:flex-row gap-6 md:gap-4 lg:gap-5 text-body-sm lg:text-body-md",
    accordionWrapper: "md:w-1/2 overflow-hidden",
    accordion: "object-cover object-center w-full flex",
    content:
      "flex flex-col gap-4 items-start md:w-1/2 justify-start md:gap-6 lg:gap-8 ",
    text: "",
    link: "",
  },
  variants: {
    layout: {
      vertical: {
        wrapper: "flex flex-col",
      },
      horizontal: {
        wrapper: "flex flex-row",
      },
      "horizontal-reverse": {
        wrapper: "flex flex-row-reverse",
      },
      "vertical-reverse": {
        wrapper: "flex flex-col-reverse",
      },
    },
  },
});
